<template>
    <Modal>
        <template v-slot:header>
            <div class="d-flex justify-content-between w-100 align-items-center">
                <div></div>
                <h2 class="fw-bold fs-3">CALCRIM {{juryInstruction?.InstructionNumber}}: {{formatUnicode(juryInstruction.InstructionTitle)}}</h2>
                <button class="btn btn-gray btn-xl" @click="$emit('close')">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </template>
        <template v-slot:body>
            <div class="d-flex flex-column fs-5">
                <div class="d-flex tab-hidden">
                    <div class="tab" v-for="(subsection, index) in juryInstruction.subsections"
                        @click="selectedSubsection = subsection"
                        :class="{
                            'tab-active': selectedSubsection.Id == subsection.Id,
                            'tab-inactive': selectedSubsection.Id != subsection.Id,
                            'border-right': index == juryInstruction.subsections.length - 1
                        }"
                    >{{subsection.SectionTitle}}</div>
                </div>
                <select class="form-control tab-show fs-5 mb-5" v-model="selectedSubsection"> 
                    <option v-for="subsection in juryInstruction.subsections" :key="subsection.Id" :value="subsection">
                        {{ subsection.SectionTitle }}
                    </option>
                </select>

                <div class="border p-5 d-flex flex-column">
                    <h3 class="mb-3 fw-bold">{{selectedSubsection.SectionTitle}}</h3>
                    <p class="mb-3" v-for="line in formatTextToArray(selectedSubsection.SectionText)">{{line}}</p>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>
import Modal from "../../../components/utils/Modal.vue";
export default {
  name: "JuryInstructionsDetailsModal",
  props: ['juryInstruction'],
  components: {
    Modal,
  },
  data() {
    return {
      selectedSubsection: null,
    };
  },
  methods: {
    openModal(juryInstructions) {
      this.juryInstructions = juryInstructions;
      this.$refs.modal.show();
    },
    formatUnicode(str) {
      str = str.replaceAll("&amp;", "&");
      str = str.replaceAll("&quot;", '"');
      str = str.replaceAll("&gt;", ">");
      str = str.replaceAll("&lt;", "<");
      str = str.replace(/\n\n\d+\s*\n\n/g, "\n");
      return str;
    },
    formatTextToArray(str) {
        return str.split('\n')
    }
  },
  mounted() {
    this.selectedSubsection = this.juryInstruction.subsections[0];
  },
};
</script>